import React from "react"
import { Main, Wrapper } from "./style"

const VideoSection = ({ link }) => {
  return (
    <Main>
      <Wrapper>
        <iframe src={link}></iframe>
      </Wrapper>
    </Main>
  )
}

export default VideoSection
